import { registerMutation } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const submitInteraction = ({
  upgradeKey
}) => http.post(`/upgrade-management-service/v1/interactions/${upgradeKey}`);
export const TRACK_UMS_INTERACTION = registerMutation({
  fieldName: 'umsInteraction',
  args: ['upgradeKey'],
  fetcher: submitInteraction
});